import { Shield, Lock, FileText, Users, Eye, AlertCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

export function HIPAAPrivacyNotice() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-center mb-12">
        <Shield className="h-16 w-16 text-blue-600 mx-auto mb-4" />
        <h1 className="text-4xl font-bold text-gray-900 mb-4">HIPAA Privacy Notice</h1>
        <p className="text-xl text-gray-600">
          This notice describes how medical information about you may be used and disclosed
          and how you can get access to this information.
        </p>
      </div>

      <div className="prose prose-lg max-w-none">
        <div className="bg-blue-50 rounded-lg p-6 mb-8">
          <h2 className="flex items-center text-2xl font-bold text-gray-900 mb-4">
            <Lock className="h-6 w-6 text-blue-600 mr-2" />
            Your Rights
          </h2>
          <p className="text-gray-600 mb-4">
            When it comes to your health information, you have certain rights under federal and Georgia law. This section explains your rights and some of our responsibilities.
          </p>
          <ul className="space-y-4">
            <li className="flex items-start">
              <FileText className="h-5 w-5 text-blue-600 mr-3 mt-1" />
              <div>
                <h3 className="font-semibold">Get a copy of your medical record</h3>
                <p className="text-gray-600">You can ask to see or get an electronic or paper copy of your medical record and other health information we have about you.</p>
              </div>
            </li>
            <li className="flex items-start">
              <Eye className="h-5 w-5 text-blue-600 mr-3 mt-1" />
              <div>
                <h3 className="font-semibold">Request confidential communications</h3>
                <p className="text-gray-600">You can ask us to contact you in a specific way (for example, home or office phone) or to send mail to a different address.</p>
              </div>
            </li>
          </ul>
        </div>

        <div className="mb-8">
          <h2 className="flex items-center text-2xl font-bold text-gray-900 mb-4">
            <Users className="h-6 w-6 text-blue-600 mr-2" />
            Our Uses and Disclosures
          </h2>
          <p className="text-gray-600 mb-4">We may use and share your information as we:</p>
          <ul className="space-y-4">
            <li className="flex items-start">
              <div className="h-5 w-5 text-blue-600 mr-3 mt-1">•</div>
              <p className="text-gray-600">Treat you and coordinate your care</p>
            </li>
            <li className="flex items-start">
              <div className="h-5 w-5 text-blue-600 mr-3 mt-1">•</div>
              <p className="text-gray-600">Run our organization and improve your care</p>
            </li>
            <li className="flex items-start">
              <div className="h-5 w-5 text-blue-600 mr-3 mt-1">•</div>
              <p className="text-gray-600">Bill for your services</p>
            </li>
            <li className="flex items-start">
              <div className="h-5 w-5 text-blue-600 mr-3 mt-1">•</div>
              <p className="text-gray-600">Comply with the law</p>
            </li>
          </ul>
        </div>

        <div className="bg-yellow-50 rounded-lg p-6 mb-8">
          <h2 className="flex items-center text-2xl font-bold text-gray-900 mb-4">
            <AlertCircle className="h-6 w-6 text-yellow-600 mr-2" />
            Your Choices
          </h2>
          <p className="text-gray-600 mb-4">
            For certain health information, you can tell us your choices about what we share.
          </p>
          <p className="text-gray-600">
            You have both the right and choice to tell us to:
          </p>
          <ul className="mt-4 space-y-2">
            <li className="text-gray-600">• Share information with your family, close friends, or others involved in your care</li>
            <li className="text-gray-600">• Share information in a disaster relief situation</li>
            <li className="text-gray-600">• Include your information in a hospital directory</li>
          </ul>
        </div>

        <div className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Responsibilities</h2>
          <ul className="space-y-4">
            <li className="flex items-start">
              <Shield className="h-5 w-5 text-blue-600 mr-3 mt-1" />
              <p className="text-gray-600">Maintain the privacy and security of your protected health information</p>
            </li>
            <li className="flex items-start">
              <AlertCircle className="h-5 w-5 text-blue-600 mr-3 mt-1" />
              <p className="text-gray-600">Let you know promptly if a breach occurs that may compromise your information</p>
            </li>
            <li className="flex items-start">
              <FileText className="h-5 w-5 text-blue-600 mr-3 mt-1" />
              <p className="text-gray-600">Follow the duties and privacy practices described in this notice</p>
            </li>
          </ul>
        </div>

        <div className="bg-gray-50 rounded-lg p-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Changes to This Notice</h2>
          <p className="text-gray-600 mb-4">
            We can change the terms of this notice, and the changes will apply to all information we have about you. The new notice will be available upon request, in our office, and on our website.
          </p>
          <p className="text-gray-600">
            Effective Date: March 25, 2024
          </p>
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-6">
            If you have questions about this notice, please contact:
          </p>
          <div className="space-y-2">
            <p className="font-semibold">Juncos Neuro Consulting</p>
            <p>1100 Northside Forsyth Dr., Suite 210</p>
            <p>Cumming, GA 30041</p>
            <p>Phone: (470) 239-3602</p>
            <p>Email: clinic@juncosneuroconsulting.com</p>
          </div>
        </div>
      </div>
    </div>
  );
}